import { useGetFamilyOrganizations } from 'api/family'
import { useParams } from 'react-router-dom'
import Spinner from 'components/Spinner'
import './styles/styles.scss'
import { Avatar, Empty } from 'antd'
import {
  ArrowCounterClockwise,
  Clock,
  Star,
  UserPlus,
} from '@phosphor-icons/react'
import { getNameSignature } from 'helper/utility'
const Organizations = () => {
  let { id }: any = useParams()

  const { data, isLoading, isFetching, refetch, isError } =
    useGetFamilyOrganizations(id)

  console.log(data, 'data...')

  return (
    <div className="mt-20">
      {isLoading || isFetching ? (
        <div className="flex align-center justify-center py-40">
          <Spinner />
        </div>
      ) : isError ? (
        <div className="flex align-center justify-center py-40">
          Something went wrong.<br></br>Please try again later
        </div>
      ) : (
        <div className="organization-container">
          {data.length > 0 ? (
            <div className="grid">
              {data?.map(organization => {
                return (
                  <div className={`organization-container`}>
                    <div className={`flex gap-16px`}>
                      <div>
                        <Avatar
                          className="pointer"
                          size={54}
                          src={organization?.photo?.post}
                        >
                          {getNameSignature(organization?.name)}
                        </Avatar>
                      </div>

                      <div>
                        <div className="pointer">
                          <h3 className="text-14 w-600">
                            {organization?.name}
                          </h3>
                          <h3 className="text-gray text-13 w-600">
                            $
                            {`${
                              organization?.credit
                                ? organization?.credit.toFixed(2)
                                : '0.00'
                            }`}{' '}
                            <span className="inline w-400">credits</span>
                          </h3>
                        </div>
                        <div className="mt-5px">
                          <button
                            className={`flex justify-between align-center border-none px-16px py-7px radius-6`}
                          >
                            {
                              <div className="flex align-center gap-10px">
                                {organization?.subscribed ? (
                                  <Star size={16} color="#000" />
                                ) : organization?.requested ? (
                                  <Clock size={16} color="#000" />
                                ) : organization?.followed ? (
                                  <UserPlus size={16} color="#000" />
                                ) : organization?.past ? (
                                  <ArrowCounterClockwise
                                    size={16}
                                    color="#000"
                                  />
                                ) : null}
                                <p className="text-14 w-400">
                                  {' '}
                                  {organization?.subscribed
                                    ? 'Subscribed'
                                    : organization?.requested
                                    ? 'Requested'
                                    : organization?.followed
                                    ? 'Followed'
                                    : organization?.past
                                    ? 'Past'
                                    : null}
                                </p>
                              </div>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="flex align-center justify-center py-40">
              <Empty />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default Organizations
